function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.085)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -0.085)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M372.165,281.848h-7.1a2.928,2.928,0,0,0-2.928,2.928v16.645a2.929,2.929,0,0,0,2.929,2.927h7a2.927,2.927,0,0,0,2.927-2.927V284.672A2.824,2.824,0,0,0,372.165,281.848Zm-3.6,21.347a1.04,1.04,0,1,1,1.04-1.04A1.039,1.039,0,0,1,368.561,303.2Z",
  transform: "translate(-362.133 -281.763)",
  fill: "#39a95e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.03,15.725a.787.787,0,1,0,1.113,1.112l2.622-2.622a.786.786,0,0,0,0-1.112L8.142,10.481A.787.787,0,1,0,7.03,11.593l1.881,1.88a.262.262,0,0,1,0,.371Z",
  transform: "translate(9.332 -10.25)",
  fill: "#097b41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.587,15.823h4.2a.787.787,0,1,0,0-1.573h-4.2a.787.787,0,0,0,0,1.573Z",
  transform: "translate(9.575 -10.056)",
  fill: "#097b41"
})));

var SvgMobileDeveloper = function SvgMobileDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.144,
    height: 22.585,
    viewBox: "0 0 27.144 22.585",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile_developer.5d106789.svg";
export { ForwardRef as ReactComponent };